// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/assets/less/app_brown.less
// module id = ./resources/assets/less/app_brown.less
// module chunks = 0